<template>
	<Modal v-model="show" wrapper-class="intro-help" modal-class="fullscreen-modal" :title="lang('tutorial_info').title"
		@before-open="beforeOpen" @before-close="beforeClose">
		<div class="modal-content">
			<div class="slides-wrapper">
				<div class="help-slide tutorial-1" :class="{ 'active': currentSlide === 1 }">
					<div class="text">
						<div v-html="lang('tutorial_info').step_1.top"></div>
					</div>
					<div class="bg-wrap">
						<div class="bg">
							<div class="arrow">
								<div class="mouse"></div>
							</div>
							<div class="more"></div>
						</div>
					</div>
					<div class="text">
						<div v-html="lang('tutorial_info').step_1.bottom"></div>
					</div>
				</div>
				<div class="help-slide tutorial-2" :class="{ 'active': currentSlide === 2 }">
					<div class="text">
						<div v-html="lang('tutorial_info').step_2.top"></div>
					</div>
					<div class="bg-wrap">
						<div class="bg">
							<div class="top-text-img"></div>
							<div class="arrow"></div>
						</div>
					</div>
					<div class="text"></div>
				</div>
				<div class="help-slide tutorial-3" :class="{ 'active': currentSlide === 3 }">
					<div class="text top-section">
						<div v-html="lang('tutorial_info').step_3.top"></div>
					</div>
					<div class="bg-wrap">
						<div class="bg">
							<div class="player"></div>
							<div class="arrow"></div>
						</div>
					</div>
					<div class="text bottom-section">
						<div v-html="lang('tutorial_info').step_3.bottom"></div>
					</div>
				</div>
				<div class="help-slide tutorial-4" :class="{ 'active': currentSlide === 4 }">
					<div class="text top-section">
						<div v-html="lang('tutorial_info').step_4.top"></div>
					</div>
					<div class="bg-wrap">
						<div class="bg">
							<div class="read"></div>
							<div class="arrow-top"></div>
							<div class="evidence"></div>
							<div class="arrow-bottom"></div>
						</div>
					</div>
					<div class="text" v-html="lang('tutorial_info').step_4.bottom"></div>
				</div>
				<div class="help-slide tutorial-5" :class="{ 'active': currentSlide === 5 }">
					<div class="text">
						<div v-html="lang('tutorial_info').step_5.top"></div>
					</div>
					<div class="bg-wrap">
						<div class="bg">
							<div class="menu"></div>
							<div class="arrow"></div>
						</div>
					</div>
					<div class="text"></div>
				</div>
			</div>
			<div class="row help-footer">
				<div class="col-2">
					<div class="float-left">
						<a href="#" @click.prevent="prevSlide" class="prev-help-slide"
							:class="{ 'd-none': currentSlide === 1 }"><svg class="icon icon-chevrons-right">
								<use xlink:href="#icon-chevrons-right"></use>
							</svg></a>
					</div>
				</div>
				<div class="col-8 d-flex justify-content-center">
					<div v-for="index in 5" class="point" :class="{ 'active': currentSlide === index }"></div>
				</div>
				<div class="col-2">
					<div class="float-right">
						<a href="#" @click.prevent="nextSlide" class="next-help-slide"
							:class="{ 'd-none': currentSlide === 5 }"><svg class="icon icon-chevrons-right">
								<use xlink:href="#icon-chevrons-right"></use>
							</svg></a>
					</div>
				</div>
			</div>
		</div>
	</Modal>
</template>

<script>
import Modal from '@kouts/vue-modal';
import helpers from '../../util/helpers';
import { store } from '../store.js'

export default {
	name: 'IntroHelp',
	props: ['showModal'],
	inject: ['lang'],
	components: {
		Modal
	},
	data() {
		return {
			currentSlide: 1,
			show: false,
			store,
		};
	},
	created() {
		this.$watch('showModal', (newVal) => {
			this.show = newVal;
		}, { immediate: true });
		const eventTarget = document.querySelector('#app');
		eventTarget.addEventListener('trigger-tutorial', e => {
			this.show = true;
		});
	},
	methods: {
		beforeOpen() {
			helpers.disableScrolling();
		},
		beforeClose() {
			this.show = false;
			helpers.enableScrolling();
			helpers.setIntroSeen();
			this.$tutorial.value = true;
			this.store.showTutorial = false;
		},
		nextSlide() {
			if (this.currentSlide < 6) {
				this.currentSlide++;
			}
		},
		prevSlide() {
			if (this.currentSlide > 1) {
				this.currentSlide--;
			}
		}
	}
}
</script>

<style lang="scss">
.vm-wrapper {
	.vm-btn-close {
		&:before {
			background-color: red;
			display: inline-block;
			width: 27px;
			height: 27px;
			border-radius: 50%;
			font-size: 30px;
			font-weight: bold;
			line-height: 29px;
			transition: 0.3s;
		}

		&:hover {
			&:before {
				transform: scale(1.2);
			}
		}

		&:active,
		&:focus {
			outline: 0;
		}
	}
}

.vm-wrapper .vm {
	top: auto;
}

.fullscreen-modal {
	width: 70%;
	max-width: 70%;
	margin: 0;
	height: 100%;
	display: flex;
	flex-direction: column;
	//background-color: transparent;
	position: absolute;
	top: 50% !important;
	left: 50%;
	transform: translateX(-50%) translateY(-50%);
	border-radius: 20px;
	background-color: #000000dd;
	overflow: hidden;

	.vm-titlebar {
		border-bottom-width: 0px;
	}

	.modal-content {
		background-color: transparent;
		height: 100%;
		border: none;
	}
}

.fullscreen-modal .vm-titlebar {
	flex-shrink: 0;
}

.fullscreen-modal .vm-content {
	padding: 0;
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	min-height: 0;
	color: white;
}

.fullscreen-modal .vm-content .scrollable-content {
	position: relative;
	overflow-y: auto;
	overflow-x: hidden;
	padding: 10px 15px 10px 15px;
	flex-grow: 1;
}

.vm-backdrop {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: #00000080;
}

.vm-wrapper {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	overflow-x: hidden;
	overflow-y: auto;
	outline: 0;
}

.vm-titlebar {
	padding: 10px 15px;
	overflow: auto;
	border-bottom: 1px solid #e5e5e5;
	display: flex;
	justify-content: space-between;
}

.vm-btn-close {
	color: #ccc;
	padding: 0;
	cursor: pointer;
	background: 0 0;
	border: 0;
	float: right;
	font-size: 24px;
	line-height: 1em;
	width: 30px;
	height: 30px;
}

.vm-btn-close:before {
	content: "\d7";
	background-color: #000;
	border: 1px solid #fff;
	font-weight: normal;
	color: #fff;
	font-size: 25px;
	font-family: "Bradley-Bold";
	line-height: 32px;
	width: 30px;
	height: 30px;
}

.intro-help {
	.fullscreen-modal {
		border: 2px solid #fff;
		height: 50vw;
		max-width: 1100px;
		max-height: 750px;
		min-width: 900px;
		min-height: 700px;
		@media(min-width: 600px) and (max-width: 1280px) {
			zoom: 0.65;
		}

		@media(max-width: 600px) {
			min-width: auto;
			width: 90% !important;
		}

		@media(max-width: 375px) {
			zoom: 0.8;
		}

		@media(max-width: 320px) {
			zoom: 0.6;
		}

		@media(max-height: 450px) and (orientation: landscape) {
			zoom: 0.5;
		}

		@media(max-height: 350px) and (orientation: landscape) {
			zoom: 0.45;
		}

		@media(max-height: 315px) and (orientation: landscape) {
			zoom: 0.40;
		}

		@media(max-height: 280px) and (orientation: landscape) {
			zoom: 0.35;
		}

	}


	.vm-titlebar {
		background-color: #a13833;

		.vm-btn-close {
			position: relative;
			top: 2px;

			&:before {
				background-color: #000;
				border: 1px solid #fff;
				font-weight: normal;
				color: #fff;
				font-size: 25px;
				font-family: 'Bradley-Bold';
				line-height: 32px;
				width: 30px;
				height: 30px;
			}
		}
	}

	.vm-title {
		font-family: "american-typewriter", "Courier New", Courier, monospace;
		color: #fff;
		font-size: 25px;
		line-height: 35px;
		margin: 0;
	}

	.vm-content {
		.modal-content {
			background-color: #fff;
			color: #000;
			padding: 1rem 1rem 0 1rem;
		}
	}

	.help-footer {
		background-color: #000;
		margin-top: 1rem;

		@media(max-width: 1080px) {
			margin-left: -1rem;
			margin-right: -1rem;
		}

		.point {
			width: 10px;
			height: 10px;
			background-color: #fff;
			border-radius: 50%;
			margin: 20px 2px;
			transition: 0.3s;

			&.active {
				background-color: #fbb03b;
			}
		}
	}

	.next-help-slide,
	.prev-help-slide {
		display: inline-block;
		font-size: 1.8rem;
		color: #fff;

		.icon {
			display: inline-block;
			width: 1em;
			height: 1em;
			stroke-width: 0;
			stroke: currentColor;
			fill: currentColor;
		}
	}

	.prev-help-slide {
		transform: rotate(-180deg) translateY(-5px);
	}

	.slides-wrapper {
		width: 100%;
		height: 100%;
		overflow: hidden;
		position: relative;

		.help-slide {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			visibility: hidden;
			opacity: 0;
			transition: 0.5s;
			font-family: "Zilla Slab", "Courier New", Courier, monospace;

			&.active {
				visibility: visible;
				opacity: 1;
			}

			.text {
				min-height: 5rem;
				display: flex;
				flex-direction: column;
				justify-content: center;
				text-align: center;
				font-size: 1.5rem;
				line-height: 1.5rem;
				font-weight: normal;

				@media(max-width: 600px) {
					font-size: 1.2rem;
					line-height: 1.2rem;
					margin: 0 9%;
				}
			}

			.bg-wrap {
				flex-grow: 1;
				margin-left: 120px;
				margin-right: 120px;
				position: relative;

				@media(max-width: 600px) {
					margin-left: 0;
					margin-right: 0;
				}

			}

			.bg {
				height: 100%;
				background-image: url(/themes/rise-theme/dist/images/estate/help-screenshot.png);
				background-size: contain;
				background-repeat: no-repeat;
				background-position: center;

				@media(max-width: 600px) {
					background-image: url(/themes/rise-theme/dist/images/estate/help-screenshot-mobile.png);
				}
			}

		}
	}

	.tutorial-1 {
		display: flex;
		flex-direction: column;

		.arrow {
			background-image: url(/themes/rise-theme/dist/images/estate/tutorial-arrow-1.png);
			background-size: contain;
			background-repeat: no-repeat;
			width: 300px;
			height: 40%;
			position: absolute;
			top: -48px;
			left: -10%;

			@media(max-width: 600px) {
				width: 80px;
				height: 30%;
				top: -24px;
				left: 4%;
			}
		}

		.mouse {
			background-image: url(/themes/rise-theme/dist/images/estate/mouse-1.png);
			background-size: contain;
			background-repeat: no-repeat;
			background-position: center;
			width: 120px;
			height: 90%;
			position: absolute;
			top: 192px;
			left: -14%;

			@media(max-width: 600px) {
				top: 92px;
				left: -54%;
			}
		}

		.more {
			background-image: url(/themes/rise-theme/dist/images/estate/theres-more-1.png?v1);
			background-size: contain;
			background-repeat: no-repeat;
			background-position: center;
			width: 50%;
			height: 60%;
			position: absolute;
			top: 170px;
			right: -16%;

			@media(max-width: 600px) {
				top: 170px;
				right: 30%;
				width: 40%;
				background-image: url(/themes/rise-theme/dist/images/estate/theres-more-1-mobile.png?v1);
			}
		}

		&.active {
			.mouse {
				animation: 2s linear 3 bounce;
			}

			.more {
				animation: 1s ease-in-out infinite pulse;
			}
		}
	}

	.tutorial-2 {
		display: flex;
		flex-direction: column;

		.top-text-img {
			background-image: url(/themes/rise-theme/dist/images/estate/top-text-2.png);
			background-size: contain;
			background-repeat: no-repeat;
			background-position: center;
			width: 80%;
			height: 250px;
			position: absolute;
			top: -40px;
			left: 10%;
			transition: 1s;
			transform: translateX(-800px);
		}

		.arrow {
			background-image: url(/themes/rise-theme/dist/images/estate/arrow-2.png);
			background-size: contain;
			background-repeat: no-repeat;
			background-position: center;
			width: 30%;
			height: 30%;
			position: absolute;
			top: -20px;
			right: -4%;
			opacity: 0;
			transition: 0.5s;
			transition-delay: 1s;

			@media(max-width: 600px) {
				background-image: url(/themes/rise-theme/dist/images/estate/tutorial-arrow-1.png);
				top: -50px;
				left: 3%;
				transform: rotate(-10deg);
			}
		}

		&.active {
			.top-text-img {
				transform: translateX(0px);
			}

			.arrow {
				opacity: 1;
				transform: rotate(-57deg);
			}
		}
	}

	.tutorial-3 {
		display: flex;
		flex-direction: column;

		.bottom-section {
			visibility: hidden;
		}
		@media screen and (orientation: landscape) {
			.top-section {
				visibility: hidden;
			}

			.bottom-section {
				visibility: visible;
			}
		}
		@media(max-width: 600px) {
			.top-section {
				visibility: hidden;
			}

			.bottom-section {
				visibility: visible;
			}
		}

		.player {
			background-image: url(/themes/rise-theme/dist/images/estate/tape-player-3.png);
			background-repeat: no-repeat;
			background-size: contain;
			background-position: center;
			width: 55%;
			height: 64%;
			position: absolute;
			left: -12%;
			top: 40px;

			@media(max-width: 600px) {
				left: 15%;
				top: 200px;
				width: 35%;
			}
		}

		.arrow {
			background-image: url(/themes/rise-theme/dist/images/estate/arrow-3.png);
			background-repeat: no-repeat;
			background-size: contain;
			width: 45%;
			height: 55%;
			position: absolute;
			left: -5%;
			top: -60px;

			@media(max-width: 600px) {
				background-image: url(/themes/rise-theme/dist/images/estate/arrow-4-bottom.png);
				width: 15%;
				height: 15%;
				left: 39%;
				top: 315px;
			}
		}

		&.active {
			.player {
				animation: 1s ease-in-out 3 pulse;
			}
		}

	}

	.tutorial-4 {
		display: flex;
		flex-direction: column;

		.read {
			background-image: url(/themes/rise-theme/dist/images/estate/read-4.png);
			background-repeat: no-repeat;
			background-size: contain;
			background-position: center;
			width: 42%;
			height: 70%;
			position: absolute;
			left: -4.4%;
			top: 1%;

			@media(max-width: 600px) {
				left: 32.4%;
				top: 54%;
				width: 37%;
			}
		}

		.arrow-top {
			background-image: url(/themes/rise-theme/dist/images/estate/arrow-4-top.png);
			background-repeat: no-repeat;
			background-size: contain;
			background-position: center;
			width: 40%;
			height: 40%;
			position: absolute;
			left: -6%;
			top: -71px;

			@media(max-width: 600px) {
				background-image: url(/themes/rise-theme/dist/images/estate/tutorial-arrow-1.png);
				width: 28%;
				height: 40%;
				left: 74%;
				top: 325px;
				transform: rotate(143deg);
				z-index: 1;
			}
		}

		.evidence {
			background-image: url(/themes/rise-theme/dist/images/estate/evidence-4.png);
			background-repeat: no-repeat;
			background-size: contain;
			background-position: center;
			width: 42%;
			height: 70%;
			position: absolute;
			left: -5%;
			top: 48%;

			@media(max-width: 600px) {
				width: 37%;
				left: 52%;
				top: 54%;
			}
		}

		.arrow-bottom {
			background-image: url(/themes/rise-theme/dist/images/estate/arrow-4-bottom.png);
			background-repeat: no-repeat;
			background-size: contain;
			background-position: center;
			width: 10%;
			height: 15%;
			position: absolute;
			left: 20%;
			bottom: -30px;

			@media(max-width: 600px) {
				left: 28%;
				bottom: -30px;
				transform: rotate(85deg);
			}
		}

		.bottom-text-mobile {
			display: none;
		}

		@media(max-width: 600px) {
			.top-section {
				visibility: hidden;
			}

			.bottom-text-desktop {
				display: none;
			}

			.bottom-text-mobile {
				display: block;
			}

		}

		&.active {

			.read,
			.evidence {
				animation: 1s ease-in-out 3 pulse;
			}
		}
	}

	.tutorial-5 {
		display: flex;
		flex-direction: column;

		@media(min-width: 600px) {
			.bg {
				background-image: url(/themes/rise-theme/dist/images/estate/bg-5.png) !important;
			}
		}


		.menu {
			background-image: url(/themes/rise-theme/dist/images/estate/menu-5.png);
			background-repeat: no-repeat;
			background-size: contain;
			background-position: center;
			width: 43%;
			height: 125%;
			position: absolute;
			left: -15%;
			top: -12.6%;
			transition: 0.2s;
			transform: translateX(0px);

			@media(max-width: 600px) {
				background-image: url(/themes/rise-theme/dist/images/estate/menu-5-mobile.png);
				width: 100%;
				height: 100%;
				top: 0;
			}
		}

		.arrow {
			background-image: url(/themes/rise-theme/dist/images/estate/arrow-5.png);
			background-repeat: no-repeat;
			background-size: contain;
			background-position: center;
			width: 32%;
			height: 50%;
			position: absolute;
			left: 17%;
			top: -61px;
			transition: 0.5s;

			@media(max-width: 600px) {
				left: 58%;
				top: -86px;
				transform: rotate(-43deg);
			}
		}

		&.active {
			.menu {
				animation: 2s linear 1 slide-right;
			}

			@media(min-width: 600px) {
				.arrow {
					animation: 1s ease-in-out 0.5s 1 pulse;
				}
			}
		}
	}
}

@keyframes slide-right {
	0% {
		transform: translateX(0px);
	}

	25% {
		transform: translateX(-50px);
	}

	45% {
		transform: translateX(-20px);
	}

	65% {
		transform: translateX(-10px);
	}

	85% {
		transform: translateX(5px);
	}

	100% {
		transform: translateX(0px);
	}
}

@keyframes fade-in {
	0% {
		opacity: 0;
	}

	100% {
		opacity: 1;
	}
}
</style>
